// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"15e35be9","36":"b4fbd16b","137":"e5916ef3","561":"51936a7f","878":"737a324b"}[chunkId] + ".chunk.js";
};